// extracted by mini-css-extract-plugin
export default {"privacy":"Privacy_privacy__EX1Sf","infoSpan":"Privacy_infoSpan__HfFBR","privacyPolicy":"Privacy_privacyPolicy__VeqRd","privacyPolicyTitle":"Privacy_privacyPolicyTitle__+mrFR"};